export const colorList = [
  { color: 'amber', name: 'Amber' },
  { color: 'blue', name: 'Blue' },
  { color: 'lightblue', name: 'Light blue' },
  { color: 'brown', name: 'Brown' },
  { color: 'green', name: 'Green' },
  { color: 'grey', name: 'Grey' },
  { color: 'darkgrey', name: 'Dark grey' },
  { color: 'lavender', name: 'Lavender' },
  { color: 'lime', name: 'Lime' },
  { color: 'magenta', name: 'Magenta' },
  { color: 'mint', name: 'Mint' },
  { color: 'orange', name: 'Orange' },
  { color: 'pink', name: 'Pink' },
  { color: 'lightpink', name: 'Light pink' },
  { color: 'purple', name: 'Purple' },
  { color: 'red', name: 'Red' },
  { color: 'slate', name: 'Slate' },
  { color: 'tan', name: 'Tan' },
  { color: 'tangerine', name: 'Tangerine' },
  { color: 'turquoise', name: 'Turquoise' },
  { color: 'yellow', name: 'Yellow' },
];

export const colorOptions: SelectOption[] = colorList.map((color) => {
  return {
    key: color.color,
    label: color.name,
    value: color.color,
  };
});

export function getRandomColorWithExclusions({ excludedColors }: { excludedColors: string[] }) {
  let colorsToUse = colorList.filter((color) => !excludedColors.includes(color.color));

  if (colorsToUse.length === 0) {
    colorsToUse = colorList;
  }
  return colorsToUse[Math.floor(Math.random() * colorsToUse.length)].color;
}
